module.exports = __webpack_public_path__ + "static/media/logo.7bb7f864.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.gif
// module id = 948
// module chunks = 0